import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=6087049b&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=6087049b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087049b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6087049b')) {
      api.createRecord('6087049b', component.options)
    } else {
      api.reload('6087049b', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=6087049b&scoped=true&", function () {
      api.rerender('6087049b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6AepnnsWrY6/JS/comp/DateRangeExt.vue"
export default component.exports